import axios from "axios";

export const API = axios.create({
 baseURL: "https://0855mq40p3.execute-api.us-east-1.amazonaws.com/dev",

});

// -----------------------------
// CONTRATOS TELEFÓNICOS
// -----------------------------
export const getContratos = () => API.get("/contratos");
export const createContrato = (data) => API.post("/contratos", data);
export const updateContrato = (id, data) => API.put(`/contratos/${id}`, data);
export const deleteContrato = (id) => API.delete(`/contratos/${id}`);
